import { FC } from 'react'

import { Button } from '@/components/ui'

import Download from '@/assets/icons/download-simple.svg'

interface IProps {
	disabled: boolean
	generateAllFolders: () => void
	totalTimeHighlights: string
}

const HighlightFooterControls: FC<IProps> = ({
	disabled,
	generateAllFolders,
	totalTimeHighlights
}) => {
	return (
		<div className='flex gap-2 justify-between absolute z-10 bottom-0 inset-x-0 p-3 backdrop-blur-sm bg-white/10'>
			<Button
				className='rounded-[8px] bg-neutral-900 w-full hover:bg-neutral-700'
				classNameText='flex items-center gap-3 text-[18px] !leading-[100%]'
				disabled={disabled}
				onClick={generateAllFolders}
			>
				<Download className='w-[18px] h-[18px]' />
				<span>Download all ({totalTimeHighlights})</span>
			</Button>
		</div>
	)
}

export default HighlightFooterControls
